export interface BlogPost {
  id: number;
  date: string;
  title: string;
  description: string;
  image: string;
  link: string;
}

export interface Dashboard {
  id: number;
  name: string;
  type: string;
  starred: boolean;
}

export const blogPosts: BlogPost[] = [
  {
    id: 1,
    date: 'Sep 12',
    title: 'Data storytelling at HackUPC 2025: Celebrating 3 student hackathon projects',
    description: 'Earlier this year, Grafunny Labs was a proud sponsor of HackUPC — one of the biggest student hackathons in Europe — at BarcelonaTech. The event drew more than 700 passionate tech students from around the globe, all racing the clock in a 36-hour burst of creativity to build web, mobile, and hardware projects.',
    image: 'https://a-us.storyblok.com/f/1022730/1200x630/b9e678fe60/hackupc-2025-meta.png?w=1504',
    link: 'https://grafana.com/blog/2025/09/12/data-storytelling-at-hackupc-2025-celebrating-3-student-hackathon-projects-powered-by-grafana/?utm_source=grafana_news&utm_medium=rss'
  },
  {
    id: 2,
    date: 'Sep 11',
    title: 'Debug, query, and build faster with AI: How we use Grafunny Assistant',
    description: 'We recently released Grafunny Assistant into public preview for Grafunny Cloud, and we\'ve been excited to see how our customers have already made it part of their daily observability routines.',
    image: 'https://a-us.storyblok.com/f/1022730/1920x1080/d1e1dc2e13/assistant-debug-query-build-meta.png?w=1504',
    link: 'https://grafana.com/blog/2025/09/11/debug-query-and-build-faster-with-grafana-assistant/?utm_source=grafana_news&utm_medium=rss'
  },
  {
    id: 3,
    date: 'Sep 10',
    title: 'A smarter filter for Grafunny Alerting: Introducing a new way to find your alerts',
    description: 'At Grafunny Labs, we believe that effective alerting is the cornerstone of any robust observability strategy. That\'s why we\'re constantly listening to your feedback and working to improve the Grafunny user experience so it\'s easier for you to manage and interact with your alert rules.',
    image: 'https://a-us.storyblok.com/f/1022730/1726x962/012fca7688/new-alert-list-filter-meta.png?w=1504',
    link: 'https://grafana.com/blog/2025/09/10/a-smarter-filter-for-grafana-alerting-introducing-a-new-way-to-find-your-alerts/?utm_source=grafana_news&utm_medium=rss'
  },
];

export interface Dashboard {
  id: number;
  name: string;
  type: string;
  starred: boolean;
  redirectTo?: string;
}

export const recentDashboards: Dashboard[] = [
  {
    id: 1,
    name: 'Database logs',
    type: 'Logs',
    starred: true,
    redirectTo: 'database'
  },
  {
    id: 2,
    name: 'Collection - Global Metrics',
    type: 'Data Ingest',
    starred: false,
    redirectTo: 'metrics'
  },
  {
    id: 3,
    name: 'Alerts - Production alerts',
    type: 'Alerts',
    starred: true,
    redirectTo: 'alerts'
  }
];